module.exports = __webpack_public_path__ + "static/media/vision-10.7c6bfbea.jpg";